import React, { useState, useRef } from "react";

import { AsyncTypeahead, Highlighter } from "react-bootstrap-typeahead";

// apollo
import { useApolloClient } from "@apollo/react-hooks";

// query
import { FIND_CLIENT_BY_NAME, UPDATE_PHONE } from "../querys/client.query";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

// react select
import Select from "react-select";

// swalert2
import Swal from "sweetalert2";

// component
import PhoneInput from "../components/phone.component";

// selector
import { useSelector } from "react-redux";

import "../scss/menu.scss";

const PhoneClient = () => {
  const token = useSelector((state) => state.default.user);

  const client = useApolloClient();

  const clientTypeHead = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [typePhone, setTypePhone] = useState(null);

  const optionsTypePhone = [
    { value: "CEL", label: "Celular" },
    { value: "COM", label: "Comercial" },
  ];

  const handleSearch = async (query) => {
    if (query.length < 3) {
      return;
    }

    setIsLoading(true);

    console.log("query", query);

    const variables = {
      name: query,
    };

    try {
      const result = await client.query({
        query: FIND_CLIENT_BY_NAME,
        variables: variables,
        fetchPolicy: "no-cache",
      });

      console.log("result", result);
      const data = result.data.findClientByName;

      const json = data.map((ele) => {
        return {
          id: ele.id.toString(),
          codigo: ele.codigo.toString(),
          razonSocial: ele.razonSocial.toString(),
          nombreFantasia: ele.nombreFantasia.toString(),
          domicilio: ele.domicilio ? ele.domicilio.toString() : null,
          telefono: ele.telefono ? ele.telefono.toString() : null,
        };
      });
      console.log("json", json);
      setOptions(json);

      setIsLoading(false);
    } catch (error) {
      console.log(error);

      setIsLoading(false);
    }
  };
  const filterBy = (element) => {
    return true;
  };

  const onChangeClient = (selected) => {
    console.log("selected client", selected);

    if (selected && selected.length > 0) {
      setSelectedClient(selected[0]);
    } else {
      setSelectedClient(null);
    }
  };

  const onChangeTypePhone = (option) => {
    console.log("option", option);
    setTypePhone(option);
  };

  const save = async () => {
    const phone = document.getElementById("phone").value;

    if (!typePhone) {
      Swal.fire(
        "Validacion Teléfono",
        "Por favor seleccione un tipo de Teléfono",
        "warning"
      );
      return;
    }

    const phoneStr = phone ? phone.replaceAll(" ", "") : "";

    if (phoneStr.length < 14) {
      Swal.fire(
        "Validacion Teléfono",
        "Por favor complete el teléfono con el formato requerido",
        "warning"
      );
      return;
    }

    const variables = {
      cli_id: parseInt(selectedClient.id),
      phone: phoneStr,
      type: typePhone.value,
      id_default: true,
      current_user: token.token,
    };

    const result = await client.query({
      query: UPDATE_PHONE,
      variables: variables,
      fetchPolicy: "no-cache",
    });

    const data = result.data.updateClientPhone;

    if (data) {
      Swal.fire(
        "Actualización de Teléfono",
        "La actualización se hizo correctamente",
        "success"
      );
      clear();
    } else {
      Swal.fire(
        "Actualización de Teléfono",
        "Se produjo un error al intentar actualizar el registro. Por favor intente mas tarde.",
        "error"
      );
    }

    console.log("phone", variables);
  };

  const clear = () => {
    setSelectedClient(null);
    // document.getElementById('phone').value  = '';
    clientTypeHead.current.clear();
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <form>
          <label>Buscar un cliente</label>
          <AsyncTypeahead
            ref={clientTypeHead}
            filterBy={filterBy}
            id="async-example"
            isLoading={isLoading}
            labelKey="razonSocial"
            minLength={3}
            onSearch={handleSearch}
            onChange={onChangeClient}
            options={options}
            placeholder="Buscar un cliente"
            renderMenuItemChildren={(option, props, index) => {
              return [
                <Highlighter key="address" search={props.text}>
                  {option.razonSocial}
                </Highlighter>,
                <div key="door_number">
                  <small>{option.nombreFantasia}&nbsp;|&nbsp;</small>
                  <small>{option.codigo}&nbsp;|&nbsp;</small>
                  <small>{option.domicilio}</small>
                </div>,
              ];
            }}
          />
        </form>
      </div>
      {selectedClient && (
        <div className="col-12 mt-3">
          <div className="row">
            <div className="col-12">
              <label>
                {" "}
                <strong>Codigo Cliente:</strong>{" "}
                <span> {selectedClient.codigo}</span>{" "}
              </label>
            </div>
            <div className="col-12">
              <label>
                <strong>Razon Social:</strong>{" "}
                <span> {selectedClient.razonSocial}</span>{" "}
              </label>
            </div>
            <div className="col-12">
              <label>
                <strong>Nombre Fantasía:</strong>{" "}
                <span> {selectedClient.nombreFantasia}</span>{" "}
              </label>
            </div>
            <div className="col-12">
              <label>
                <strong>Domicilio:</strong>{" "}
                <span> {selectedClient.domicilio}</span>{" "}
              </label>
            </div>
            <div className="col-12">
              <label>
                <strong>Teléfono:</strong>{" "}
                <span> {selectedClient.telefono}</span>{" "}
              </label>
            </div>
          </div>
        </div>
      )}{" "}
      {selectedClient && (
        <div className="col-md-6 mt-3">
          <div className="form-group">
            <label htmlFor="phone">Teléfono</label>
            <PhoneInput className="form-control" id="phone" />
            <small id="phone_help" className="form-text text-muted">
              ingrese el formato del teléfono +54 9343 5456 789
            </small>
          </div>
        </div>
      )}{" "}
      {selectedClient && (
        <div className="col-12 mt-3">
          <div className="row">
            <div className="col-md-6">
              <Select
                options={optionsTypePhone}
                placeholder="Seleccionar Tipo"
                isClearable
                onChange={onChangeTypePhone}
              />
            </div>
          </div>
        </div>
      )}
      <div className="col-12 mt-3">
        <div className="row">
          <div className="col-auto mt-3">
            <button
              type="button"
              className="btn btn-success ml-3"
              onClick={save}
            >
              <FontAwesomeIcon icon={faSave} />
              <span className="ml-1">Guardar</span>
            </button>
          </div>
          <div className="col-auto mt-3">
            <button
              type="button"
              className="btn btn-warning ml-3"
              onClick={clear}
            >
              <FontAwesomeIcon icon={faExclamationCircle} />
              <span className="ml-1">Limpiar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneClient;
